<template lang="pug">
  .chatlogs
    .page-header
      h2 Chatlogs - {{game === 'cod4' ? 'CoD4' : 'CS:GO'}}
      .content-search
        select(v-model="selectedServer" @change="selectChange")
          option(v-if="game === 'cod4'" v-for="(value, index) in Object.values(servers)" :key="value" :value="Object.keys(servers)[index]") {{ value }}
          option(v-if="game === 'csgo'" v-for="(value, index) in servers" :key="value" :value="index") {{ value }}
        input(type="text", :placeholder="`Search by ${game === 'cod4' ? 'B3 Id' : 'Steam Id'}...`", v-model="searchTerm", @keyup.enter="search").filtered.buttoned
        .search-go(@click="search")
          magnify-icon

    csgo-chatlog(:logs="logs" v-if="game === 'csgo'" :updateFilter="updateOrder")
    cod-chatlog(:logs="logs" v-if="game === 'cod4'" :updateFilter="updateOrder")

    pagination(:page="$route.query.page", :pages="pages")
</template>

<script>
import ChatlogService from '@/services/Chatlogs';
import Pagination from '@/components/core/Pagination.vue';

import MenuUpIcon from 'vue-material-design-icons/MenuUp.vue';
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';

import CodChatlog from '@/components/CodChatlog.vue';
import CsgoChatlog from '@/components/CsgoChatlog.vue';

export default {
  name: 'chatlogs',
  components: {
    Pagination,
    MenuUpIcon,
    MenuDownIcon,
    MagnifyIcon,
    CodChatlog,
    CsgoChatlog,
  },
  data() {
    return {
      logs: [],
      pages: 1,
      searchTerm: this.$route.query.search || '',
      servers: [],
      selectedServer: '',
      supportedGames: ['csgo', 'cod4'],
      game: this.$route.params.game,
      order: this.$route.query.order || 'DESC',
    };
  },
  methods: {
    async update() {
      this.selectedServer = this.$route.query.server || '';
      this.order = this.$route.query.order || 'DESC';
      this.game = this.$route.params.game;

      const { page, server } = this.$route.query;
      if (!this.game || !this.supportedGames.includes(this.game) || !server) {
        // Default to cod4 and dr because that shit ain't going anywhere
        this.$router.push({ name: 'chatlogs-game', params: { game: 'cod4' }, query: { server: 'dr' } });
        return;
      }

      if (!page) {
        this.$route.query.page = 1;
      }

      this.servers = (await ChatlogService.getServers(this.game === 'cod4' ? 'q3' : 'csgo')).data;

      // Redirect if the server doesn't exist #failsafe
      if (!Object.keys(this.servers).includes(server)) {
        this.$router.push({ name: 'chatlogs-game', params: { game: this.game }, query: { server: Object.keys(this.servers)[0] } });
        return;
      }

      const logs = (await ChatlogService.getLogs(this.game === 'cod4' ? 'q3' : 'csgo', server, page, this.searchTerm, this.order)).data;
      this.pages = logs.pages;
      this.logs = logs.data;
    },
    search() {
      // Is this really the best way to do this? :cry:
      this.$router.push({ name: 'chatlogs-game', params: { ...this.$route.params }, query: { ...this.$route.query, search: this.searchTerm, page: 1 } });
    },
    selectChange() {
      this.$router.push({ name: 'chatlogs-game', params: { ...this.$route.params }, query: { ...this.$route.query, server: this.selectedServer, page: 1 } });
    },
    updateOrder(order) {
      if (order === this.order) {
        return;
      }

      this.$router.push({ name: 'chatlogs-game', params: { ...this.$route.params }, query: { ...this.$route.query, order } });
    },
  },
  created() {
    this.update();
  },
  watch: {
    $route() {
      this.update();
    },
  },
};
</script>

<style lang="scss" scoped>
.clients {
  table tr td {
    cursor: pointer;
  }
}
</style>
